/* 種子亂數。對局邏輯的亂數一律走這裡，rnd()（Math.random）只准用在純視覺用途。
   見 core/math.ts 的 rnd 註解。無任何相依。 */

/* ---------- 種子亂數（對局用） ---------- */
export var RNG = {
  s: 1,
  seed: function (n) { this.s = (n >>> 0) || 1; },
  next: function () {
    this.s |= 0; this.s = (this.s + 0x6D2B79F5) | 0;
    var t = Math.imul(this.s ^ (this.s >>> 15), 1 | this.s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
};
export function rr(a, b) { return a + RNG.next() * (b - a); }
export function rri(a, b) { return Math.floor(a + RNG.next() * (b - a + 1)); }
export function rpick(arr) { return arr[Math.floor(RNG.next() * arr.length)]; }
export function newSeed() { return (Math.random() * 0xFFFFFFFF) >>> 0; }
export function seedStr(n) { return ('00000000' + n.toString(36).toUpperCase()).slice(-6); }
